// API服务文件
// 使用 chatanywhere 免费API：https://github.com/chatanywhere/GPT_API_free

import { XStream } from 'ant-design-x-vue';

// API Key 改为从环境变量读取（VUE_APP_AI_API_KEY，见 .env / .env.example）
const API_KEY = process.env.VUE_APP_AI_API_KEY || ''; // 请在此填写您的API密钥（从 chatanywhere 获取）
const API_URL = '/ai-api/v1/chat/completions';

/**
 * 调用LongCat API获取AI回复（流式）
 * @param {string} message - 用户输入的消息
 * @param {Array} history - 对话历史
 * @param {Function} onChunk - 接收流式数据的回调函数
 * @returns {Promise<string>} - 完整的AI回复内容
 */
export const getAIResponse = async (message, history = [], onChunk) => {
  try {
    const recentHistory = history.slice(-5);
    const messages = [
      ...recentHistory.map(item => ({
        role: item.role,
        content: item.content
      })),
      {
        role: 'user',
        content: message
      }
    ];
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);

    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${API_KEY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages,
        max_tokens: 1000,
        temperature: 0.7,
        top_p: 0.9,
        stream: true
      }),
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`API请求失败: ${response.status} ${response.statusText}`);
    }

    if (!response.body) {
      throw new Error('响应体为空，文档要求流式响应需返回text/event-stream');
    }

    let completeResponse = '';

    // 使用XStream处理SSE流式响应
    for await (const chunk of XStream({
      readableStream: response.body
    })) {
      try {
        // XStream返回的对象包含data属性，data是JSON字符串
        let rawData;
        if (!chunk) {
          continue;
        }
        
        // 获取数据内容
        let dataContent = '';
        if (typeof chunk === 'object' && chunk.data) {
          dataContent = chunk.data;
        } else if (typeof chunk === 'string') {
          dataContent = chunk;
        }
        
        // 检查是否是[DONE]标记（可能有多种格式）
        if (dataContent && (dataContent === '[DONE]' || 
                            dataContent.trim() === '[DONE]' || 
                            dataContent.includes('[DONE]'))) {
          continue;
        }
        
        // 尝试解析JSON
        if (dataContent) {
          // 处理可能的"data: "前缀
          const jsonStr = dataContent.startsWith('data: ') ? dataContent.substring(6) : dataContent;
          rawData = JSON.parse(jsonStr);
        } else {
          rawData = chunk;
        }
        
        // 标准OpenAI格式：内容在choices[0].delta.content
        if (rawData.choices && rawData.choices.length > 0) {
          const delta = rawData.choices[0].delta || {};
          const deltaChunk = delta.content || '';
          
          if (deltaChunk) {
            completeResponse += deltaChunk;
            
            // 触发前端流式更新
            if (typeof onChunk === 'function') {
              onChunk(deltaChunk);
            }
          }
        }
      } catch (e) {
        // 忽略[DONE]相关的解析错误
        if (!e.message.includes('[DONE]')) {
          console.error('解析XStream chunk失败:', e);
        }
      }
    }

    return completeResponse;
  } catch (error) {
    console.error('❌ API调用异常:', error);
    throw error;
  }
};